// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__Z9Z4k","Logo":"Header_Logo__QSduJ","Desktop":"Header_Desktop__XclNE","Mobile":"Header_Mobile__rfabw"};